import { CheckCircle, Briefcase, MessageSquare, Activity, FileText, Users, Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function ActionRequiredEmpty() {
  return (
    <div className="bg-white border border-gray-200 rounded-xl p-8 shadow-sm">
      <div className="flex items-center gap-3 mb-7">
        <div className="p-2.5 bg-green-100 rounded-xl">
          <CheckCircle className="w-6 h-6 text-green-600" />
        </div>
        <div>
          <h2 className="text-xl font-bold text-gray-900 tracking-tight">All Caught Up</h2>
          <p className="text-sm text-gray-600 mt-0.5">No pending actions at this time</p>
        </div>
      </div>
      <div className="text-center py-12">
        <div className="inline-flex p-4 bg-green-50 rounded-2xl mb-4">
          <CheckCircle className="w-12 h-12 text-green-600" />
        </div>
        <p className="text-gray-600 text-sm">You're all set! No contracts or documents need your attention right now.</p>
      </div>
    </div>
  );
}

export function ActiveProjectsEmpty() {
  const navigate = useNavigate()
  return (
    <div>
      <div className="mb-6">
        <h2 className="text-xl font-[500] text-gray-900 tracking-tight">Active Projects</h2>
        <p className="text-sm text-gray-600 mt-1">Your current workload</p>
      </div>
      <div className="bg-white border-2 border-dashed border-gray-300 rounded-xl p-16 text-center">
        <div className="inline-flex p-4 bg-gray-50 rounded-2xl mb-4">
          <Briefcase className="w-12 h-12 text-gray-400" />
        </div>
        <h3 className="font-[500] text-gray-900 mb-2">No active projects</h3>
        <p className="text-sm text-gray-600 mb-6">Create a project when you're ready to start new work.</p>
        <button onClick={()=>{
          navigate("/create-contract")
        }} className="contractor-empty-action">
          <Plus size={16} aria-hidden="true" />
          Create project
        </button>
      </div>
    </div>
  );
}

export function MessagesEmpty() {
  return (
    <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
      <div className="flex items-center justify-between mb-5">
        <h3 className="font-[500] text-gray-900 tracking-tight">Notifications</h3>
      </div>
      <div className="text-center py-12">
        <div className="inline-flex p-4 bg-gray-50 rounded-2xl mb-4">
          <MessageSquare className="w-10 h-10 text-gray-400" />
        </div>
        <p className="text-sm text-gray-600">No new notification</p>
      </div>
    </div>
  );
}

export function RecentActivityEmpty() {
  return (
    <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
      <h3 className="font-[500] text-gray-900 mb-5 tracking-tight">Recent Activity</h3>
      <div className="text-center py-12">
        <div className="inline-flex p-4 bg-gray-50 rounded-2xl mb-4">
          <Activity className="w-10 h-10 text-gray-400" />
        </div>
        <p className="text-sm text-gray-600">No recent activity</p>
      </div>
    </div>
  );
}

export function ContractsEmpty() {
  const navigate = useNavigate()
  return (
    <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
      <h3 className="font-[500] text-gray-900 mb-5 tracking-tight">Contracts</h3>
      <div className="text-center py-16">
        <div className="inline-flex p-4 bg-gray-50 rounded-2xl mb-4">
          <FileText className="w-12 h-12 text-gray-400" />
        </div>
        <h4 className="font-[500] text-gray-900 mb-2">No contracts yet</h4>
        <p className="text-sm text-gray-600 mb-6">Your contracts will appear here after you create one.</p>
        <button onClick={()=>{
          navigate("/create-contract")
        }} className="contractor-empty-action contractor-empty-action--compact">
          <Plus size={16} aria-hidden="true" />
          Create contract
        </button>
      </div>
    </div>
  );
}


export function IncomingLeadsEmpty() {
    return (
      <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h3 className="font-[500] text-gray-900 tracking-tight">Open Leads</h3>
            <p className="text-sm text-gray-600 mt-1">0 new opportunities</p>
          </div>
        </div>
        <div className="text-center py-16">
          <div className="inline-flex p-4 bg-gray-50 rounded-2xl mb-4">
            <Users className="w-12 h-12 text-gray-400" />
          </div>
          <h4 className="font-[500] text-gray-900 mb-2">No incoming leads</h4>
          <p className="text-sm text-gray-600">New leads will appear here when homeowners request quotes</p>
        </div>
      </div>
    );
  }
  
  export function AcceptedLeadsEmpty() {
    return (
      <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h3 className="font-[500] text-gray-900 tracking-tight">Accepted Leads</h3>
            <p className="text-sm text-gray-600 mt-1">0 leads in progress</p>
          </div>
        </div>
        <div className="text-center py-16">
          <div className="inline-flex p-4 bg-gray-50 rounded-2xl mb-4">
            <CheckCircle className="w-12 h-12 text-gray-400" />
          </div>
          <h4 className="font-[500] text-gray-900 mb-2">No accepted leads</h4>
          <p className="text-sm text-gray-600">Leads you accept will be tracked here</p>
        </div>
      </div>
    );
  }
